import { ApiResponse } from 'apisauce';
import { IResponseSnapshot } from 'src/models/response/Response';

import { IDept, IUserDeptRole, IUserDeptRoleSnapshot } from '../../models';
import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import {
  TDeleteUserDeptRoleResult,
  TGetAccessibleDeptsResult,
  TGetUserDeptRolesResult,
  TPostUserDeptRoleResult,
  TUpdateUserDeptRoleResult,
} from './UserDeptRoleTypes';

/**
 * # UserDeptRole Api 서비스
 *
 * 사용자 다중 부서 역할 (겸직) 관리 API
 */
export class UserDeptRoleApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async gets(userSid: number): Promise<TGetUserDeptRolesResult> {
    try {
      const url = `/v1/users/${userSid}/dept-roles`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const userDeptRoles: IUserDeptRole[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', userDeptRoles, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async post(userSid: number, data: IUserDeptRoleSnapshot): Promise<TPostUserDeptRoleResult> {
    try {
      const url = `/v1/users/${userSid}/dept-roles`;
      const response: ApiResponse<any> = await this.api.apisauce.post(url, data);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const userDeptRole: IUserDeptRole = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', userDeptRole, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async update(userSid: number, data: IUserDeptRoleSnapshot): Promise<TUpdateUserDeptRoleResult> {
    try {
      const url = `/v1/users/${userSid}/dept-roles/${data.userDeptRoleSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.put(url, data);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const userDeptRole: IUserDeptRole = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', userDeptRole, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async delete(userSid: number, userDeptRoleSid: number): Promise<TDeleteUserDeptRoleResult> {
    try {
      const url = `/v1/users/${userSid}/dept-roles/${userDeptRoleSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async getAccessibleDepts(): Promise<TGetAccessibleDeptsResult> {
    try {
      const url = `/v1/users/me/accessible-depts`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const accessibleDepts: IDept[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: 'ok', accessibleDepts, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
